module.exports = __webpack_public_path__ + "assets/user.f2109181.svg";